import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShareRoutingModule } from './share-routing.module';
import { TopModule } from './top/top.module';
import { NoteModule } from './note/note.module';
import { FolderModule } from './folder/folder.module';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { ErrorsModule } from '../errors';
import { SharePasswordModule } from './password';
import { TabsModule } from './tabs';

import { ShareComponent } from './share.component';
import { ShareSmartComponent } from './share-smart.component';
import { ShareItemComponent } from './share-item.component';
import { ShareNoteComponent } from './share-note.component';
import { ShareFolderComponent } from './share-folder.component';
import { ShareUploadingComponent } from './share-uploading.component';
import { VideoAttachmentComponent } from './video-attachment.component';
import { AudioAttachmentComponent } from './audio-attachment.component';
import { ImageAttachmentComponent } from './image-attachment.component';
import { AttachmentComponent } from './attachment.component';
import { SpamComponent } from './spam.component';
import { CloseAttachmentComponent } from './close-attachment.component';
import { ToTopComponent } from './to-top.component';
import { ReloadComponent } from './reload.component';
import { NoteEncryptedComponent } from './note-encrypted.component';
import { BrandingModule } from '../branding';
import { ShareConfigComponent } from './share-config.component';
import { FormsModule } from '@angular/forms';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { ShareConfigPopupComponent } from './share-config-popup.component';
import { WorkspacesModule } from '../workspaces';

@NgModule({
  imports: [
    ShareRoutingModule,
    ErrorsModule,
    TopModule,
    NoteModule,
    FolderModule,
    CommonModule,
    NimbusCommonModule,
    RouterModule,
    SharePasswordModule,
    TabsModule,
    BrandingModule,
    FormsModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    WorkspacesModule,
  ],
  declarations: [
    CloseAttachmentComponent,
    ShareComponent,
    ShareSmartComponent,
    ShareNoteComponent,
    ShareFolderComponent,
    ShareUploadingComponent,
    ShareItemComponent,
    NoteEncryptedComponent,
    SpamComponent,
    ToTopComponent,
    VideoAttachmentComponent,
    AudioAttachmentComponent,
    ImageAttachmentComponent,
    ShareConfigComponent,
    ShareConfigPopupComponent,
    AttachmentComponent,
    ReloadComponent
  ],
  entryComponents: [
    ShareConfigPopupComponent
  ]
})
export class ShareModule { }
